<div *ngIf="displayPagination" class="row pagination-wrapper hidden">
    <div class="col-2 previous-page-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
        </svg>
        <a id="previousPageButton" class="disabled" role="button" href="#" title="{{'prevPageTitleText' | i18next}}" (click)="getPreviousPage($event);">{{'prevLinkText' | i18next}} {{this.pageCountLabel}}</a>
    </div>
    <div class="col-2 next-page-wrapper">
        <a id="nextPageButton" class="disabled" role="button" href="#" title="{{'nextPageTitleText' | i18next}}"
            (click)="getNextPage($event);">{{'nextLinkText' | i18next}} {{this.pageCountLabel}}</a>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-caret-right-fill"
            viewBox="0 0 16 16">
            <path
                d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
        </svg>
    </div>
</div>

<div *ngIf="!hideFrillsLexicon()" class="row thesaurus-bottom-row">
        <div class="col-6">
            <div class="term-count-wrapper">
              <span class="term-value strong">{{termsService.getTermCount()}}</span> {{'selected_subjectsText' | i18next}}
                <a href="#" role="button" id="openModal" (click)="modal.openModal($event)">{{'view' | i18next}}</a>

                <!--MODAL COMPONENT-->
                <app-modal #modal [modalId]="'selectedTermsModal'" [explode]="isExplode" [major]="isMajor" [thesaurusId]="thesaurusId"></app-modal>
            </div>
        </div>

        <div *ngIf="!noResults()" class="col-6 radioBtnCol">
            <div class="radioBtnWrapper">
                <div class="andOrRadio">
                    <div role="radioGroup">
                        <div class="radioLabel">{{'label_combine_using' | i18next}}</div>
                        <label class="switch" *ngFor="let type of joinTypes">
                            <input type="radio" name="joinType" [checked]="type.default" [(ngModel)]="joinType" [value]="type.value" />
                            <span>{{type.label}}</span>
                        </label>
                    </div>
                </div>
                <div class="addToSearch">
                    <app-add-term-banner></app-add-term-banner>
                    <button type="button" class="btn btn-pq-brand" (click)="submitThesaurusEntries($event);">{{'button_add' | i18next}}</button>
                    <a class="closeLink" href="javascript:window.close();">{{'button_close' | i18next}}</a>
                </div>
            </div>
        </div>
    </div>